<template>
  <div class="timeslots">
    <summary-item v-for="pet in selectedPets" :key="pet.id" :pet="pet"/>
    <total-amount/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SummaryItem from './SummaryItem.vue'
import TotalAmount from './TotalAmount.vue'

export default {
  name: 'DisplayHeaderSummary',
  computed: {
    ...mapState('BookingUpload', [
      'selectedPets'
    ])
  },
  components: {
    'summary-item': SummaryItem,
    'total-amount': TotalAmount
  }
}
</script>
